/**
 * Created by pablo on 8/22/17.
 */

var integrate;
var form = "integrate_form";
(function ($, undefined) {
    'use strict';

    integrate = {};
    integrate.form = $("#"+form);
    integrate.showAcceptModal = function(e){
        e.preventDefault();
    };

    integrate.save = function(e){
        e.preventDefault();
        integrate.form.submit();
        $("#accept_invitation").hide()
    };

    //binding
    $("#submit_button").on('click',integrate.showAcceptModal);
    $("#accept").on('click',integrate.save);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/integrate.js